import * as React from "react";
import { Modal, ModalSize, ModalBody, ModalFooter, Form, AlertMessage, AlertType, CustomButton, ButtonType, CustomSubmitButton, Checkbox } from "soprasteria-ui-library";
import { useAuth } from "../../../../App";
import { PatientApi } from "../../../../api/PatientApi";

interface IReactivateFreeDentalCareForm {
    patientId: number;
    onReactivateFreeDentalCareSuccess: () => any;
}

export const ReactivateDentalCareModal: React.FunctionComponent<IReactivateFreeDentalCareForm> = ({ patientId, onReactivateFreeDentalCareSuccess }) => {
    const auth = useAuth();
    const api = new PatientApi(auth);
    const [errorMessage, setErrorMessage] = React.useState<string>("");
    const [isFormLoading, setIsFormLoading] = React.useState<boolean>(false);

    const onSubmit = () => {
        setIsFormLoading(true);
        api.reactivateFreeDentalCare(patientId, () => {
            onReactivateFreeDentalCareSuccess();
        }, (errorMessage: string) => {
            setIsFormLoading(false);
            setErrorMessage(errorMessage);
        })
    }

    return (
        <Modal header="Återgå till avgiftsfri tandvård" id="reactivate-free-dental-care-modal" preventCloseOnOutsideClick={false} modalSize={ModalSize.normal}>
            <Form onSubmit={onSubmit}>
                <ModalBody>
                    <AlertMessage alertType={AlertType.danger} duration={3000} >{errorMessage}</AlertMessage>
                    <p>Är du säker på att patienten åter vill ta del av avgiftsfri tandvård?</p>
                    <Checkbox value="agreement" label="Jag bekräftar att en överenskommelse finns" name="agreement" id="agreement" required labelCol={9} inputCol={3} />
                </ModalBody>
                <ModalFooter>
                    <div className="text-right btn-group" role="group">
                        <CustomButton buttonType={ButtonType.general} data-dismiss="modal" buttonText="Avbryt" />
                        <CustomSubmitButton isLoading={isFormLoading}>Återgå till avgiftsfri tandvård</CustomSubmitButton>
                    </div>
                </ModalFooter>
            </Form>
        </Modal>
    )
}